import React from 'react';
import Notifications from './Notifications';

const NotificationsLoader = (props) => {
  if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
    return (
      <div id='site-notifications-wrapper' style={{ display: 'flex' }}>
        <Notifications { ...props } />
      </div>
    );
  }

  return null;
};

export default NotificationsLoader;
